// Stage 2 "Dashboard" · 2.3 (g) — "My time, last 7 days": the signed-in user's own hours per engagement; time on deleted
// engagements as one line (→ the recycle bin).
import React from "react";
import { FD, TARGET, fmtSeconds } from "./fdTheme";
import { FdLink, Panel, Empty } from "./FdPrimitives";

export default function FdMyTime({ rows, t, lang }) {
  const list = Array.isArray(rows) ? rows : [];
  const h = (s) => fmtSeconds(s, lang, t);   // SUNDAY BATCH D-6: below 0.1 h in minutes, with its unit
  const live = list.filter((r) => r.engagement_id);
  const deletedSecs = list.filter((r) => !r.engagement_id).reduce((a, r) => a + Number(r.seconds || 0), 0);
  const total = list.reduce((a, r) => a + Number(r.seconds || 0), 0);
  return (
    <Panel title={t("fd.myTime.title")} testid="fd-my-time"
           right={<span className="text-sm font-semibold tabular-nums" style={{ color: FD.thText }}>{t("fd.myTime.total")}: {h(total)}</span>}>
      {list.length === 0 ? <Empty>{t("fd.myTime.empty")}</Empty> : (
        <div className="flex flex-wrap gap-2">
          {live.map((r) => (
            <FdLink key={r.engagement_id} to={TARGET.engagements} engId={r.engagement_id} testid={`fd-my-time-${r.engagement_id}`}
                    className="rounded px-3 py-1.5 text-sm" style={{ background: FD.cell, border: `1px solid ${FD.rowLine}` }}>
              <span className="font-medium">{r.client_name}</span>
              <span className="ms-2 tabular-nums" style={{ color: FD.muted }}>{h(r.seconds)}</span>
            </FdLink>
          ))}
          {deletedSecs > 0 && (
            <FdLink to={TARGET.recycleBin} testid="fd-my-time-deleted" className="rounded px-3 py-1.5 text-sm italic"
                    style={{ background: FD.cell, border: `1px dashed ${FD.rowLine}`, color: FD.muted }}>
              {t("fd.myTime.deleted")}<span className="ms-2 tabular-nums">{h(deletedSecs)}</span>
            </FdLink>
          )}
        </div>
      )}
    </Panel>
  );
}
